import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';


export class AppConfigService {

  constructor( private platformId: Object) {}

  isPlatformServer() {
    return isPlatformServer(this.platformId);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Object, decorators: [{ type: Inject, args: [PLATFORM_ID, ] }, ]},
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
